const t={download:"download",link:"link"};export{t as variants};
//# sourceMappingURL=link-card.types.js.map
